import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../api/client";
import { RungBadge } from "../components/Rung";
import { shortDid } from "../util";
import { NameBasisBadge } from "../components/NameBasisBadge";

/** /issuer/{did}: the issuer read view. Every claim naming the issuer, who anchored it, under which delegation. */
export function IssuerPage() {
  const { did = "" } = useParams();
  const [data, setData] = useState<any>(null);
  useEffect(() => { api.GET("/issuers/{issuer_did}/claims", { params: { path: { issuer_did: did } } }).then((r) => setData(r.data ?? { claims: [] })); }, [did]);
  if (!data) return <p className="note">Loading…</p>;
  return (
    <div>
      <h1>Claims naming this issuer</h1>
      {data.issuer && <p data-testid="issuer-name"><b>{data.issuer.name}</b> <NameBasisBadge basis={data.issuer.name_basis} domain={data.issuer.domain} /></p>}
      <p className="mono">{shortDid(did)}</p>
      <div className="card" style={{ overflowX: "auto" }}>
        <table data-testid="issuer-table">
          <thead><tr><th>Claim</th><th>Rung</th><th>Anchored by</th><th>Delegation</th></tr></thead>
          <tbody>{data.claims.map((c: any) => {
            const a = c.anchors[0];
            return (<tr key={c.claim_id} data-testid="issuer-row">
              <td><Link to={`/c/${c.claim_id}`}>{c.description ?? c.claim_type}</Link><div className="hint mono">{shortDid(c.holder_did)}</div></td>
              <td><RungBadge rung={c.rung} /></td>
              <td>{a ? <>{a.attester_name ?? shortDid(a.attester_did ?? "")}<div className="hint">{a.role}{a.status === "demoted" ? " · revoked" : ""}</div></> : "Not anchored"}</td>
              <td className="mono">{a?.delegation_credential_id ?? (a ? "direct" : "")}</td>
            </tr>);
          })}</tbody>
        </table>
      </div>
    </div>
  );
}
